// extracted by mini-css-extract-plugin
export default {"organization":"eAYvLbObOnM4TJM0Rz_Q","button":"pfGWYTbNlhd6chb9QwRw","icon":"p0z8GHm2SoF8qL_5pcZK"};